module.exports = __webpack_public_path__ + "next3.dafc8e30.png";